import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { mapUtil } from '../util/mapUtil.js';
import CmprsEstmt from "./CmprsEstmt.js";
import Consulting from "./Consulting.js";
import { useNavigate } from "react-router-dom";
import { useT, currentLang, displayAddress } from "../i18n";
import MyChart from "./MyChart.js";
import RadarChartComponent from "./RadarChartComponent.js";
import PriceForecastChart from "./PriceForecastChart.js";
import AiSearchLand from "./AiSearchLand.js";

function InformationBeta(props) {
    const t = useT();
    const [tabCount, setTabCount] = useState(0);
    const [tabACount, setTabACount] = useState(0);
    const [allowBuildingCount, setAllowBuildingCount] = useState(0);
    const tabMenu = ['토지정보', '건축정보', '예상공사비'];
    const [bookMarkState, setBookMarkState] = useState(false);
    const [consultingState, setConsultingState] = useState(false);
    const [bookMarkWindow, setBookMarkWindow] = useState(false);
    const [subCategoryWindow, setSubCategoryWindow] = useState(false);
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
    const [informationScrollValue, setInformationScrollValue] = useState(0);
    const [contentHeightArray, setContentHeightArray] = useState([]);
    const [informationHeight, setInformationHeight] = useState(300);
    const [touchStartY, setTouchStartY] = useState(0);
    const [touchDistanceY, setTouchDistanceY] = useState(0);
    const [selectedBigTabMenu, setSelectedBigTabMenu] = useState(0);
    const scrollBoxRef = useRef(null);
    const [CmprsEstmtState, setCmprsEstmtState] = useState(false);
    const [selectedAiAnalysisSubTab, setSelectedAiAnalysisSubTab] = useState(0);
    const aiAnalysisSubTabMenu = ['토지평가', '가격비교', '시뮬레이션'];
    const [constructionDate, setConstructionDate] = useState('2025.08');
    const [buildingPurpose, setBuildingPurpose] = useState(''); // 건축 용도 상태 추가
    const [priceForecastData, setPriceForecastData] = useState(null);
    const [aiAnalysisResult, setAiAnalysisResult] = useState(null); // AI 분석 결과 상태
    const [simulationResult, setSimulationResult] = useState(null); // 시뮬레이션 결과 상태 추가
    const [isAiDataLoading, setIsAiDataLoading] = useState(false); // AI 데이터 통합 로딩 상태
    const [isSimulationLoading, setIsSimulationLoading] = useState(false); // 시뮬레이션 로딩 상태 추가
    const [isPriceForecastLoading, setIsPriceForecastLoading] = useState(false); // 가격비교 로딩 상태 추가
    const [aiSearchLand, setAiSearchLand] = useState(false); // AI 건축물/토지 찾기 상태 추가

    const navigate = useNavigate();
    const [randomTotalPrice, setRandomTotalPrice] = useState(0);
    function processNumber(number) {
        const integerPart = String(Math.floor(number));
        let billionsPart = integerPart.slice(0, -8);
        const thousandsPart = integerPart.slice(-8, -7);
        if (billionsPart === '') { billionsPart = '0' };
        if (currentLang === 'en') {
            // 억 단위는 영문권에 통하지 않으므로 10억(B) 단위로 환산해 보여 준다.
            return '\u20a9' + (Math.floor(number) / 1e9).toFixed(2) + 'B';
        }
        const result = `${billionsPart}.${thousandsPart}억`
        return result;
    }
    function clickBookMark() {
        if (props.userInfo === null || !props.addressInfo?.name?.jibunAddress) { window.setModalMessage(t('로그인 후 이용가능합니다.')); setBookMarkState(false); navigate('/login', { state: { returnUrl: window.location.href } }); return false }
        const user = props.userInfo;
        setSubCategoryWindow(false);
        if (bookMarkState === false) {
            if (bookMarkWindow === false) {
                setBookMarkWindow(true);
            } else if (bookMarkWindow === true) {
                setBookMarkWindow(false);
            }
        } else if (bookMarkState === true) {
            const bookmark_id = props.addressInfo.name.jibunAddress.replace(/\s{2,}/gi, ' ');
            axios({
                method: 'post',
                url: process.env.REACT_APP_BOOKMARKDELETE_SERVER_URL,
                data: {
                    _id: user._id,
                    provider: user.provider,
                    bookmark_id: bookmark_id,
                    name: null,
                    plotAr: props.addressInfo?.construct?.PLOT_AR,
                    color: '#fff'
                },
                withCredentials: true
            }).then((response) => {
                console.log(response.data);
                props.setBookMarks(response.data);
                setBookMarkState(false);
            }).catch((error) => {
                console.log(error);
                if (error.response.status === 401) {
                    window.setModalMessage(t('로그인 후 이용가능합니다.'));
                    setBookMarkState(false);
                    navigate('/login', { state: { returnUrl: window.location.href } });
                }
            });

        }

    }
    function checkBookMark() {
        if (!props.bookMarks || !props.addressInfo?.name?.jibunAddress) return false;
        setBookMarkState(false);
        if (props.bookMarks.length !== 0) {
            props.bookMarks.forEach((list_item, list_index) => {
                list_item.bookMarks.forEach((item, index) => {
                    if (item.bookmark_id.replace(/\s{2,}/gi, ' ') === props.addressInfo.name.jibunAddress.replace(/\s{2,}/gi, ' ')) {
                        console.log('북마크 있음');
                        setBookMarkState(true);
                    }
                });
            })
        }
    }
    function consulting_btn() {
        if (props.userInfo === null) { window.setModalMessage(t('로그인 후 이용가능합니다.')); setBookMarkState(false); navigate('/login', { state: { returnUrl: window.location.href } }); return false }
        if (consultingState === true) {
            setConsultingState(false);
        } else {
            setConsultingState(true);
        }
    }

    function aiPropertySearch_btn() {
        // if (props.userInfo === null) { 
        //     window.setModalMessage(t('로그인 후 이용가능합니다.')); 
        //     setBookMarkState(false); 
        //     navigate('/login', { state: { returnUrl: window.location.href } }); 
        //     return false 
        // }
        // AI 건축물/토지 찾기 기능 구현
        setAiSearchLand(true);
        console.log('AI 건축물/토지 찾기 버튼 클릭됨');
    }
    function houst_total_filter() {
        if (props.addressInfo?.estimateList && props.addressInfo.estimateList[allowBuildingCount]?.mainCategoryName === '단독주택' && props.addressInfo?.construct?.TOTAR > 400) {
            return (400)
        } else if (props.addressInfo?.construct?.TOTAR) {
            return (props.addressInfo.construct.TOTAR)
        } else {
            return 0; // Fallback for undefined TOTAR
        }
    }
    function tabClick(index) {
        const scrollBox = scrollBoxRef.current;
        if (!scrollBox || !scrollBox.parentNode || !document.contains(scrollBox)) {
            return;
        }
        if (index === 0) {
            scrollBox.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return;
        }
        const offsets = [0];
        for (let i = 0; i < contentHeightArray.length - 1; i++) {
            offsets.push(offsets[i] + contentHeightArray[i]);
        }
        const targetIndex = Math.min(index, offsets.length - 1);

        const sectionTop = offsets[targetIndex];
        const sectionHeight = contentHeightArray[targetIndex];
        let sectionCenter = sectionTop + sectionHeight / 2;

        const containerHeight = scrollBox.offsetHeight;

        const maxScroll = scrollBox.scrollHeight - containerHeight;
        if (sectionCenter < 0) sectionCenter = 0;
        if (sectionCenter > maxScroll) sectionCenter = scrollBox.scrollHeight;

        scrollBox.scrollTo({
            top: sectionCenter,
            behavior: 'smooth',
        });
    }
    function scrollBoxScrollEvent(e) {
        if (!e.target  || !document.contains(e.target) || !e.target.parentNode) return; // 안전 검사 추가
        e.preventDefault();
        setInformationScrollValue(e.target.scrollTop);
    }
    function handleTouchStart(e) {
        setTouchStartY(e.touches[0].clientY);
    };

    function handleTouchMove(e) {
        const currentY = e.touches[0].clientY;
        const distance = currentY - touchStartY;
        setTouchDistanceY(distance);
    };
    function handleTouchEnd(e) {
        let upDown = 'same';
        if (touchDistanceY > 50) {
            upDown = 'down';
        } else if (touchDistanceY < -50) {
            upDown = 'up';
        }

        const headerHeight = 182;
        const maxAvailableHeight = window.innerHeight - headerHeight;

        let newHeight = informationHeight;

        if (informationHeight === maxAvailableHeight) {
            if (touchDistanceY > 300) {
                newHeight = 20;
            } else {
                if (upDown === 'down') {
                    newHeight = 300;
                } else if (upDown === 'up') {
                    newHeight = maxAvailableHeight;
                }
            }
        }
        else if (informationHeight === 300) {
            if (upDown === 'down') {
                newHeight = 20;
            } else if (upDown === 'up') {
                newHeight = maxAvailableHeight;
            }
        }
        else if (informationHeight === 20) {
            if (touchDistanceY < -300) {
                newHeight = maxAvailableHeight;
            } else {
                if (upDown === 'down') {
                    newHeight = 20;
                } else if (upDown === 'up') {
                    newHeight = 300;
                }
            }
        }

        setInformationHeight(newHeight);
        setTouchDistanceY(0);
    }
    function checkTabHeight() {
        const scrollBox = scrollBoxRef.current;
        if (!scrollBox || !scrollBox.parentNode || !document.contains(scrollBox)) return false; // parentNode 체크 추가
        const scrollBoxHeight = scrollBox.offsetHeight;
        if (scrollBox !== null) {
            const newArray = []
            scrollBox.querySelectorAll('.content_wrap').forEach((item, index) => {
                if (!item || !item.parentNode || !document.contains(item)) return; // 안전 검사 추가
                let height = 0;
                if (index === 0) {
                    height = item.offsetHeight + 80 + 1 - scrollBoxHeight / 2;
                } else {
                    height = item.offsetHeight + 80 + 1;
                }
                newArray.push(height);
            });
            setContentHeightArray(newArray);
        }

    }
    let resetTime;
    function resizeHandle() {
        setWindowInnerWidth(window.innerWidth);
        setTabCount(0);
        clearTimeout(resetTime);
        resetTime = setTimeout(checkTabHeight, 1000);
    }
    useEffect(() => {
        setAllowBuildingCount(0);
        props.setLoadingModule(false);
        if (props.addressInfo && window.infoWindow) {
            if (props.addressInfo.estimateList && props.addressInfo.estimateList[0] && props.addressInfo.estimateList[0].mainCategoryName == undefined) {
                window.infoWindow.setContent([
                    `<div class="infoWindow">
                        <div class="allow deny">${t('건축불가')}</div>
                    </div>`
                ].join('\n'));

            } else if (props.addressInfo.estimateList && props.addressInfo.estimateList[0]) {
                let totalPrice = 0;
                if (props.testing !== true) {
                    totalPrice = applyRandomError(props.addressInfo.estimateList[allowBuildingCount].estimate.totalNumber);
                    props.setRandomPrice(numberToKoreanCurrency(totalPrice));
                } else {
                    totalPrice = koreanCurrencyToNumber(props.randomPrice);
                }
                window.infoWindow.setContent([
                    `<div class="infoWindow">
                        <div class="name">${t(props.addressInfo.estimateList[allowBuildingCount].mainCategoryName)}</div> 
                        <div class="allow">${t('건축가능')}</div>
                        <div class="estimateTotal" style=" ">${processNumber(totalPrice)}</div>
                    </div>`
                ].join('\n'));
            }
        }
        checkBookMark();
        checkTabHeight();
        setTabACount(0);
        setPriceForecastData(null);
        setAiAnalysisResult(null);
        setSimulationResult(null);
        setSelectedBigTabMenu(1);
        setTimeout(() => { setSelectedBigTabMenu(0); }, 1);

    }, [props.addressInfo]);

    useEffect(() => {
        if (selectedBigTabMenu === 2 && props.addressInfo) {
            const fetchAiData = async () => {
                window.setModalMessage(t('AI 분석을 불러오는 중입니다. 잠시만 기달려주세요.'));
                setIsAiDataLoading(true); // AI 분석 탭 전체 로딩 시작
                setSelectedAiAnalysisSubTab(0);

                try {
                    // 토지 분석 데이터 먼저 가져오기
                    // 영문 화면에서는 입력부터 영문으로 넘긴다. 한국어 주소를 그대로 주면
                    // GPT 가 요약문 안에 "관악구 신림동" 같은 한글 지명을 그대로 섞어 쓴다.
                    const landAnalysisResponse = await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/api/ai-land-analysis`, {
                        address: displayAddress(props.addressInfo?.name?.jibunAddress),
                        landUse: t(props.addressInfo?.land?.type),
                        area: props.addressInfo?.land?.size,
                        publicLandPriceList: props.addressInfo?.publicLandPriceList,
                        zoning: t(props.addressInfo?.land?.landType1),
                        landHeight: props.addressInfo?.land?.landHeight,
                        landFromCode: props.addressInfo?.land?.landFromCode,
                        lastUpdateDate: props.addressInfo?.land?.lastUpdateDate,
                        lang: currentLang, // 영문 화면이면 요약문을 영문으로 받는다
                    });
                    setAiAnalysisResult(landAnalysisResponse.data.data);
                    setIsAiDataLoading(false); // 토지 분석 데이터 로드 완료 시 메인 로딩 해제

                    // 가격 예측 데이터는 별도로 가져오기 (로딩 상태에 영향 주지 않음)
                    setIsPriceForecastLoading(true); // 가격비교 로딩 시작
                    const priceForecastResponse = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/api/ai-forecast`, {
                        params: {
                            address: props.addressInfo?.name?.jibunAddress,
                            propertyTypes: ['단독다가구', '연립다세대', '아파트', '토지']
                        }
                    });
                    const datasets = Object.keys(priceForecastResponse.data.data).map(propertyType => {
                        const forecastData = priceForecastResponse.data.data[propertyType];
                        return {
                            label: propertyType,
                            data: Object.values(forecastData),
                            borderColor: `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`,
                            backgroundColor: `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`,
                            borderWidth: 1,
                            pointRadius: 2,
                        };
                    });
                    setPriceForecastData({ datasets });
                    setIsPriceForecastLoading(false); // 가격비교 로딩 완료

                } catch (error) {
                    console.error('AI 데이터 로딩 오류:', error);
                    window.setModalMessage(t('AI 데이터 분석 중 오류가 발생했습니다.'));
                    setIsAiDataLoading(false); // 오류 발생 시에도 로딩 해제
                    setIsPriceForecastLoading(false); // 가격비교 로딩도 해제
                }
            };

            // aiAnalysisResult 또는 priceForecastData가 없을 때만 fetch
            if (!aiAnalysisResult || !priceForecastData) {
                fetchAiData();
            }
        }
        
    }, [selectedBigTabMenu, props.addressInfo]);

    useEffect(() => {
        if (props.addressInfo && window.infoWindow) {
            let totalPrice = 0;
            if (props.testing !== true) {
                totalPrice = applyRandomError(props.addressInfo?.estimateList?.[allowBuildingCount]?.estimate?.totalNumber || 0);
                props.setRandomPrice(numberToKoreanCurrency(totalPrice));
            } else {
                totalPrice = koreanCurrencyToNumber(props.randomPrice);
            }
            window.infoWindow.setContent([
                `<div class="infoWindow">
                    <div class="name">${t(props.addressInfo?.estimateList?.[allowBuildingCount]?.mainCategoryName) || t('정보 없음')}</div> 
                    <div class="allow">${t('건축가능')}</div>
                    <div class="estimateTotal">${processNumber(totalPrice)}</div>
                </div>`
            ].join('\n'));
        }

    }, [allowBuildingCount])
    useEffect(() => {

        window.addEventListener('resize', resizeHandle);
        return (() => {
            window.removeEventListener('resize', resizeHandle);
        });
    }, []);

    useEffect(() => {
        const scrollBox = scrollBoxRef.current;
        if (!scrollBox || !scrollBox.parentNode || !document.contains(scrollBox)) return; // parentNode 체크 추가

        const st = scrollBox.scrollTop;
        const ch = scrollBox.clientHeight;
        const sh = scrollBox.scrollHeight;

        if (st + ch >= sh - 10) {
            setTabCount(2);
            return;
        }

        const before_tab_01 = contentHeightArray[0];
        let before_tab_02 = before_tab_01 + contentHeightArray[1];

        if (st < before_tab_01) {
            setTabCount(0);
        } else if (st < before_tab_02) {
            setTabCount(1);
        } else {
            setTabCount(2);
        }
    }, [informationScrollValue]);


    useEffect(() => {
        const scrollBox = scrollBoxRef.current;
        if (scrollBox && scrollBox.parentNode && document.contains(scrollBox) && props.bookMarkInfoWindow === false) {
            setInformationScrollValue(0);
        }
    }, [props.bookMarkInfoWindow]);

    function applyRandomError(price, randomNumber = 9) {
        const randomErrorPercentage = Math.random() * randomNumber;
        const isPositiveError = Math.random() >= 0.5;
        const errorAmount = Math.floor((price * randomErrorPercentage) / 100);

        return isPositiveError ? price + errorAmount : price - errorAmount;
    }
    function numberToKoreanCurrency(number) {
        let units = ['원', '만', '억', '조'];
        let result = '';
        let unitIndex = 0;
        number = Math.floor(number);

        while (number > 0) {
            let chunk = number % 10000;
            if (chunk > 0) {
                result = chunk + units[unitIndex] + ' ' + result;
            }
            unitIndex++;
            number = Math.floor(number / 10000);
        }

        return result.trim();
    }
    /**
     * 화면 표시용 금액.
     * numberToKoreanCurrency() 결과는 koreanCurrencyToNumber() 가 되파싱하는 내부 표준값이라
     * 한국어를 유지해야 한다. 그래서 영문일 때만 여기서 숫자로 되돌려 다시 포맷한다.
     */
    function displayCurrency(koreanCurrency) {
        if (currentLang !== 'en' || !koreanCurrency) return koreanCurrency;
        const won = koreanCurrencyToNumber(koreanCurrency);
        if (!won) return koreanCurrency;
        return '\u20a9' + won.toLocaleString('en-US');
    }
    function koreanCurrencyToNumber(koreanCurrency) {
        const units = { '억': 1e8, '만': 1e4, '원': 1 };
        let total = 0;

        koreanCurrency = koreanCurrency.replace(/[^0-9억만원\s]/g, "");

        const parts = koreanCurrency.split(' ').filter(Boolean);
        for (let part of parts) {
            let unit = part.slice(-1);
            let number = parseInt(part.slice(0, -1), 10);

            if (units[unit] && !isNaN(number)) {
                total += number * units[unit];
            }
        }
        return total;
    }

    function handleAiSimulation() {
        if (!props.addressInfo) {
            window.setModalMessage(t('주소 정보가 없습니다.'));
            return;
        }

        const datePattern = /^\d{4}\.\d{2}$/;
        if (!constructionDate || !buildingPurpose || !datePattern.test(constructionDate)) {
            window.setModalMessage(t('건축 예정일은 YYYY.MM 형식으로 입력하고, 건축 용도를 선택해주세요.'));
            return;
        }

        setIsSimulationLoading(true);
        setSimulationResult(null);

        const simulationData = {
            address: displayAddress(props.addressInfo?.name?.jibunAddress),
            landUse: t(props.addressInfo?.land?.type),
            area: props.addressInfo?.land?.size,
            publicLandPriceList: props.addressInfo?.publicLandPriceList,
            zoning: t(props.addressInfo?.land?.landType1),
            nearbyInfo: "정보 없음",
            landHeight: props.addressInfo?.land?.landHeight,
            landFromCode: props.addressInfo?.land?.landFromCode,
            lastUpdateDate: props.addressInfo?.land?.lastUpdateDate,
            constructionDate: constructionDate,
            buildingPurpose: t(buildingPurpose),
            lang: currentLang, // 영문 화면이면 결과 문자열을 영문으로 받는다
        };

        axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/api/ai-land-simulation`, simulationData)
            .then(response => {
                setSimulationResult(response.data.data);
            })
            .catch(error => {
                console.error('AI 시뮬레이션 호출 오류:', error.response ? error.response.data : error.message);
                window.setModalMessage(t('AI 시뮬레이션 중 오류가 발생했습니다.'));
            })
            .finally(() => {
                setIsSimulationLoading(false);
            });
    }

    const getGradeFromScore = (score) => {
        if (score >= 9) return 'A';
        if (score >= 8) return 'B';
        if (score >= 7) return 'C';
        if (score >= 5.5) return 'D';
        return 'F';
    };
    return (
        <div className={`informationWrap ${props.showInformation ? 'show' : ''}`}
            style={windowInnerWidth > 1024 ? {} : { height: `${informationHeight - touchDistanceY}px` }}
        >
            <div className={`bookmark_window_cover ${bookMarkWindow === true || subCategoryWindow === true || consultingState === true || CmprsEstmtState === true ? "" : "hidden"}`} onClick={() => { setBookMarkWindow(false); setSubCategoryWindow(false); setConsultingState(false); setCmprsEstmtState(false); }}></div>
            <div className="M_infoBtn_wrap"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}>
                <div className="M_infoBtn">
                    <p className="infoBtn_line"></p>
                </div>
            </div>
            {props.addressInfo === undefined ?
                <div className="loadingModule">
                    <svg className="loadingImage" width="184" height={informationHeight === 20 ? "0" : "90"} viewBox="0 0 181 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M180,79V43L90,2.4L1.3,43V79H180Z" />
                    </svg>
                </div> :
                <>
                    {props.loadingModule === true ?
                        <div className={`loadingModule`}>
                            <svg className="loadingImage" width="184" height={informationHeight === 20 ? "0" : "90"} viewBox="0 0 181 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M180,79V43L90,2.4L1.3,43V79H180Z" />
                            </svg>
                        </div> : ''}
                    {props.bookMarkInfoWindow === true && props.userInfo !== null ?
                        <BookMarkList bookMarks={props.bookMarks} setLoadingModule={props.setLoadingModule} infoClick={props.infoClick} onClick={props.onClick} informationHeight={informationHeight} CmprsEstmtState={CmprsEstmtState} setCmprsEstmtState={setCmprsEstmtState} /> :
                        <>
                            <div className={`noneBox`}>
                                <div className="topWrap">
                                    <div className="titleBox">{displayAddress(props.addressInfo?.name?.jibunAddress)}</div>
                                    <div className='subTitleBox'>{displayAddress(props.addressInfo?.name?.roadAddress)}</div>
                                    <div className='btns btn_book_mark' onClick={clickBookMark}><img className="book_mark info_bookmark" src={bookMarkState === true ? process.env.PUBLIC_URL + "images/map/icon_bookmark_allblack.svg" : process.env.PUBLIC_URL + "images/map/icon_bookmark_black.svg"}></img></div>
                                    {props.addressInfo?.land?.landType1 !== '개발제한구역' && (
                                        <div className="allowWrap">
                                            <AllowBuildingList addressInfo={props.addressInfo} allowBuildingCount={allowBuildingCount} setAllowBuildingCount={setAllowBuildingCount} />
                                            <div className={subCategoryWindow === true ? "more_btn open" : "more_btn"} onClick={() => { setSubCategoryWindow(!subCategoryWindow); setBookMarkWindow(false); }}>{t('상세')}</div>
                                        </div>
                                    )}
                                </div>
                                <div className="bottomWrap">

                                    {props.addressInfo?.land?.landType1 === '개발제한구역' ?
                                        <div className="green_belt">
                                            {t('개발제한구역으로')}<br></br>{t('건축이 불가능한 토지입니다.')}
                                        </div>
                                        :
                                        <>

                                            <div className="bigTabMenuWrap">
                                                <div className={selectedBigTabMenu === 0 ? "bigTabMenu selected" : "bigTabMenu"} onClick={() => { setSelectedBigTabMenu(1);setTimeout(() => { setSelectedBigTabMenu(0); }, 1); }}>{t('신축정보')}</div>
                                                <div className={selectedBigTabMenu === 1 ? "bigTabMenu selected" : "bigTabMenu"} onClick={() => { setSelectedBigTabMenu(1) }}>{t('건물정보')}</div>
                                                <div className={selectedBigTabMenu === 2 ? "bigTabMenu selected gradient" : "bigTabMenu gradient"} onClick={() => { setSelectedBigTabMenu(2) }}><div className="aiGradient">{t('AI 분석')}</div><img src={`${process.env.PUBLIC_URL}images/map/ai_information_icon.svg`}></img></div>
                                            </div>
                                            {selectedBigTabMenu === 0 && props.addressInfo?.estimateList?.[allowBuildingCount] ?
                                                <div className="infoBox">
                                                    <ul className='tabMenuUl'>
                                                        {
                                                            tabMenu.map((item, index) => {
                                                                return <li key={index} className={`tabMenu ${tabCount == index ? "active" : ""}`} onClick={() => { tabClick(index) }}>{t(item)}</li>
                                                            })
                                                        }
                                                    </ul>
                                                    <div className="content_container" ref={scrollBoxRef} onScroll={scrollBoxScrollEvent}>

                                                        <>
                                                            <div className="content_wrap">
                                                                <div className="content_without_chart add_line">
                                                                    <div className="content_box">
                                                                        <div className="title">{t('토지 면적')}</div>
                                                                        <div className="content">{props.addressInfo?.land?.size}㎡<span>({(props.addressInfo?.land?.size * 0.3025).toFixed(2)}{t('평')})</span></div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('지목')}</div>
                                                                        <div className="content">{t(props.addressInfo?.land?.type)}</div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('용도')}</div>
                                                                        <div className="content">{t(props.addressInfo?.land?.landType1)}</div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('건축가능용도')}</div>
                                                                        <div className="content">{t(props.addressInfo?.allowBuildingList?.allowBuildingListSubCategory?.[allowBuildingCount]?.name)}</div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('공시지가')}</div>
                                                                        <div className="content">{Number(props.addressInfo?.publicLandPriceList?.[0]).toLocaleString()}{t('(원/㎡)')}</div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('지형높이')}</div>
                                                                        <div className="content">{props.addressInfo?.land?.landHeight}</div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('지형형상')}</div>
                                                                        <div className="content">{t(props.addressInfo?.land?.landFromCode)}</div>
                                                                    </div>
                                                                    <div className="content_box">
                                                                        <div className="title">{t('데이터기준일자')}</div>
                                                                        <div className="content">{props.addressInfo?.land?.lastUpdateDate?.split(" ")[0]}</div>
                                                                    </div>
                                                                </div>
                                                                <MyChart publicLandPriceList={props.addressInfo?.publicLandPriceList} />
                                                            </div>
                                                            <div className="row"></div>
                                                            <div className="content_wrap add_line">
                                                                <div className="content_box ">
                                                                    <div className="title">{t('토지 면적')}</div>
                                                                    <div className="content">{props.addressInfo?.land?.size}㎡<span>({(props.addressInfo?.land?.size * 0.3025).toFixed(2)}{t('평')})</span></div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('건축 면적')}</div>
                                                                    <div className="content">{props.addressInfo?.construct?.PLOT_AR}㎡<span>({(props.addressInfo?.construct?.PLOT_AR * 0.3025).toFixed(2)}{t('평')})</span></div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('연면적')}</div>
                                                                    <div className="content">{houst_total_filter()}㎡<span>({(houst_total_filter() * 0.3025).toFixed(2)}{t('평')})</span></div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('건폐율')}</div>
                                                                    <div className="content">{props.addressInfo?.gyData?.g}%</div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('용적률')}</div>
                                                                    <div className="content">{props.addressInfo?.gyData?.y}%</div>
                                                                </div>

                                                            </div>
                                                            <div className="row"></div>
                                                            <div className="content_wrap add_line">

                                                                <div className="content_box totalPrice">
                                                                    <div className="title">{t('총액')}</div>
                                                                    <div className="content">{displayCurrency(props.randomPrice)}</div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('설계비')}</div>
                                                                    <div className="content">{displayCurrency(props.addressInfo?.estimateList?.[allowBuildingCount]?.estimate?.extra)}</div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('자재비')}</div>
                                                                    <div className="content">{displayCurrency(props.addressInfo?.estimateList?.[allowBuildingCount]?.estimate?.materialsCost)}</div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('인건비')}</div>
                                                                    <div className="content">{displayCurrency(props.addressInfo?.estimateList?.[allowBuildingCount]?.estimate?.personnelCost)}</div>
                                                                </div>
                                                                <div className="content_box">
                                                                    <div className="title">{t('경비')}</div>
                                                                    <div className="content">{displayCurrency(props.addressInfo?.estimateList?.[allowBuildingCount]?.estimate?.expense)}</div>
                                                                </div>
                                                            </div>
                                                        </>

                                                    </div>
                                                </div>
                                                :
                                                selectedBigTabMenu === 1 ?
                                                    <div className="infoBox">
                                                        {props.addressInfo?.buildingInfoList?.length === 0 && (
                                                            <div className="green_belt">
                                                                {t('건물정보가 없습니다.')}
                                                            </div>
                                                        )
                                                        }
                                                        <div className="tabMenu_a">
                                                            {
                                                                (props.addressInfo?.buildingInfoList && props.addressInfo.buildingInfoList.length !== 0) && (
                                                                    props.addressInfo.buildingInfoList.map((item, index) => {
                                                                        return (
                                                                            <div className={`tab_wrap ${tabACount === index ? "select" : ""}`} >
                                                                                <div key={index} className='tab' onClick={() => { setTabACount(index) }}>{t('건물정보 {n}', { n: index })}</div>
                                                                            </div>
                                                                        )
                                                                    })

                                                                )
                                                            }

                                                        </div>
                                                        <div className="content_container">
                                                            {props.addressInfo?.buildingInfoList?.length > 0 && props.addressInfo.buildingInfoList.map((building, index) => {
                                                                if (tabACount === index) {
                                                                    const buildingArea = parseFloat(building.buildingArea || "0");
                                                                    const pyung = (buildingArea * 0.3025).toFixed(2);

                                                                    return (
                                                                        <div className="content_wrap add_line" key={index}>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건물명')}</div>
                                                                                <div className="content">{building.buildingName}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건물동명')}</div>
                                                                                <div className="content">{building.buildingDongName}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건축 면적')}</div>
                                                                                <div className="content">
                                                                                    {building.buildingArea}㎡
                                                                                    <span>({pyung}{t('평')})</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건추물구조명')}</div>
                                                                                <div className="content">{building.structureType}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('주도용도명')}</div>
                                                                                <div className="content">{building.mainUsage}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건물높이')}</div>
                                                                                <div className="content">{building.buildingHeight === "0.0" ? t("정보 없음") : building.buildingHeight}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('지상층수')}</div>
                                                                                <div className="content">{building.groundFloors}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('지하층수')}</div>
                                                                                <div className="content">{building.undergroundFloors}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('허가일자')}</div>
                                                                                <div className="content">{building.permitDate}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('총주차대수')}</div>
                                                                                <div className="content">{t('{n}대', { n: building.totParkngCo })}</div>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('총주차장면적')}</div>
                                                                                <div className="content">{building.totPrkplceAr}</div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="infoBox">
                                                        {isAiDataLoading ? (
                                                            <div className="loadingModule">
                                                                <svg className="loadingImage" width="184" height={informationHeight === 20 ? "0" : "90"} viewBox="0 0 181 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M180,79V43L90,2.4L1.3,43V79H180Z" />
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <ul className='tabMenuUl'>
                                                                    {
                                                                        aiAnalysisSubTabMenu.map((item, index) => {
                                                                            return <li key={index} className={`tabMenu aiAnalysisSubTab ${selectedAiAnalysisSubTab === index ? "active" : ""}`} onClick={() => { setSelectedAiAnalysisSubTab(index) }}>{t(item)}{item === "시뮬레이션" && (<div className="beta">βeta</div>)}</li>
                                                                        })
                                                                    }
                                                                </ul>
                                                                <div className="content_container" ref={scrollBoxRef} onScroll={scrollBoxScrollEvent}>
                                                                    {selectedAiAnalysisSubTab === 0 && aiAnalysisResult && (
                                                                        <div className="content_wrap">
                                                                            <div className="ai_land_info_wrap">
                                                                                <div className="top_wrap_border">
                                                                                    <div className="top_wrap">
                                                                                        <RadarChartComponent data={[
                                                                                            aiAnalysisResult.토지가격,
                                                                                            aiAnalysisResult.투자가치,
                                                                                            aiAnalysisResult['법적 규제'],
                                                                                            aiAnalysisResult.소음,
                                                                                            aiAnalysisResult.인구규모,
                                                                                            aiAnalysisResult.교통및접근성,
                                                                                            aiAnalysisResult['지형 및 토양'],
                                                                                            aiAnalysisResult.편의시설,
                                                                                            aiAnalysisResult['인프라 및 공공시설'],
                                                                                        ]} />
                                                                                        <div className="row white"></div>
                                                                                        <div className="bottom_wrap">
                                                                                            <div className="left_wrap">
                                                                                                <div className="title">SCORE</div>
                                                                                                <div className="point">
                                                                                                    <img src={`${process.env.PUBLIC_URL}images/map/ai_land_score_${getGradeFromScore(aiAnalysisResult.SCORE)}.png`} alt={getGradeFromScore(aiAnalysisResult.SCORE)} />
                                                                                                    <div className="score_text">{aiAnalysisResult.SCORE}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="right_wrap">
                                                                                                <div className="titles">
                                                                                                    <div className="title">{t('공시지가')}</div>
                                                                                                    <div className="title">{t('AI 평가 가치')}</div>
                                                                                                </div>
                                                                                                <div className="row verticle"></div>
                                                                                                <div className="prices">
                                                                                                    <div className="price">{parseInt(props.addressInfo?.publicLandPriceList?.[0], 10).toLocaleString()}{t('(원/㎡)')}</div>
                                                                                                    <div className="price">{parseInt(aiAnalysisResult.AI평가가치, 10).toLocaleString()}{t('(원/㎡)')}</div>
                                                                                                    <div className="difference">
                                                                                                        {(() => {
                                                                                                            const currentOfficialPrice = parseInt(props.addressInfo?.publicLandPriceList?.[0], 10);
                                                                                                            const aiEstimatedPrice = parseInt(aiAnalysisResult.AI평가가치, 10);

                                                                                                            if (isNaN(currentOfficialPrice) || isNaN(aiEstimatedPrice) || currentOfficialPrice === 0) {
                                                                                                                return '';
                                                                                                            }

                                                                                                            const difference = aiEstimatedPrice - currentOfficialPrice;
                                                                                                            const percentage = (difference / currentOfficialPrice) * 100;
                                                                                                            const sign = difference >= 0 ? '+' : '';

                                                                                                            return t('{amount}원, {percent}%', {
                                                                                                                amount: `${sign}${difference.toLocaleString()}`,
                                                                                                                percent: `${sign}${percentage.toFixed(1)}`,
                                                                                                            });
                                                                                                        })()}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                                <div className="ai_summary">
                                                                                    <div className="title">
                                                                                        <img src={`${process.env.PUBLIC_URL}/images/map/ai_summary_icon.png`}></img>
                                                                                        {t('AI 분석 요약')}
                                                                                    </div>
                                                                                    <div className="des">
                                                                                        {aiAnalysisResult.AI분석요약}
                                                                                    </div>

                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {selectedAiAnalysisSubTab === 1 && (
                                                                        priceForecastData && priceForecastData.datasets && priceForecastData.datasets.length > 0 ? (
                                                                            <div className="ai-analysis-chart-container">
                                                                                <PriceForecastChart showTable={true} priceForecastData={priceForecastData} />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="green_belt ai_analysis_empty">
                                                                                {isPriceForecastLoading ? t("내용을 불러오는중...") : t("가격 비교 정보가 없습니다.")}
                                                                            </div>
                                                                        )
                                                                    )}
                                                                    {selectedAiAnalysisSubTab === 2 && (
                                                                        <div className="content_wrap ai_simulation">
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건축 예정일')}</div>
                                                                                <input type="text" value={constructionDate} onChange={(e) => setConstructionDate(e.target.value)} className="content" />
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <div className="title">{t('건축 용도')}</div>
                                                                                <select className="content" value={buildingPurpose} onChange={(e) => setBuildingPurpose(e.target.value)}>
                                                                                    <option value="">{t('선택하세요')}</option>
                                                                                    <option value="단독주택">{t('단독다가구')}</option>
                                                                                    <option value="공동주택">{t('연립다세대')}</option>
                                                                                    <option value="상업시설">{t('아파트')}</option>
                                                                                </select>
                                                                            </div>
                                                                            <div className="content_box">
                                                                                <button className="simulation_btn" onClick={handleAiSimulation} disabled={isSimulationLoading}>
                                                                                    {isSimulationLoading ? t('시뮬레이션 중...') : t('시뮬레이션 하기')}
                                                                                </button>
                                                                            </div>
                                                                            {simulationResult && (
                                                                                <div className="ai_simulation_result">
                                                                                    {priceForecastData && priceForecastData.datasets && priceForecastData.datasets.length > 0 && <PriceForecastChart showTable={false} priceForecastData={priceForecastData} />}
                                                                                    <div className="content_wrap">
                                                                                        <div className="titles">
                                                                                            <div className="title">{t('추천 구매 시기')}</div>
                                                                                            <div className="title">{t('완공 예정일')}</div>
                                                                                            <div className="title">{t('예상 수익률')}</div>
                                                                                        </div>
                                                                                        <div className="row verticle"></div>
                                                                                        <div className="prices">
                                                                                            <div className="price">{simulationResult.추천구매시기}</div>
                                                                                            <div className="price">{simulationResult.완공예정일}</div>
                                                                                            <div className="price">{simulationResult.예상수익률}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                            }
                                            <div className={`btns btn_b ${informationHeight !== 20 ? "" : "close"}`} onClick={selectedBigTabMenu === 2 ? aiPropertySearch_btn : consulting_btn}>
                                                {selectedBigTabMenu === 2 ? t("AI 건축물/토지 찾기") : t("컨설팅 받아보기")}
                                                <div className="left-chevron"></div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>

                            {consultingState === true ?
                                <>
                                    <Consulting userInfo={props.userInfo} setConsultingState={setConsultingState} infoClick={props.infoClick} onClick={props.onClick} />
                                    <div className="consulting_background" onClick={() => { setConsultingState(false) }}></div>
                                </>
                                : ''}
                        </>
                    }
                </>
            }
            {props.userInfo === null || props.addressInfo === undefined || props.bookMarks === undefined || props.bookMarks === null ? '' :
                <BookMarkWindow userInfo={props.userInfo} bookMarkWindow={bookMarkWindow} addressInfo={props.addressInfo} setBookMarkState={setBookMarkState} setBookMarks={props.setBookMarks} bookMarks={props.bookMarks} setBookMarkWindow={setBookMarkWindow} />
            }
            {props.addressInfo === undefined ? '' :
                <AllowBuildingListSubCategory subCategoryWindow={subCategoryWindow} allowBuildingCount={allowBuildingCount} addressInfo={props.addressInfo} setSubCategoryWindow={setSubCategoryWindow} />
            }

                <>
                    <AiSearchLand aiSearchLand={aiSearchLand} setAiSearchLand={setAiSearchLand} />
                </>
        </div>
    )
}

function BookMarkList(props) {
    const t = useT();
    const [tabIndex, setTabIndex] = useState(0);
    const bookMarkTabMenu = ['전체'];
    const [selectedOptions, setSelectedOptions] = useState([]);

    function bookmarkClick(bookmark_id) {
        mapUtil.searchAddressToCoordinate(bookmark_id);
        props.setLoadingModule(true);
    }

    function EstmtBtnClick() {
        if (props.CmprsEstmtState === true) {
            props.setCmprsEstmtState(false);
        } else {
            props.setCmprsEstmtState(true);
        }
    }

    const handleCheckboxChange = (e) => {
        const value = JSON.parse(e.target.value);
        const checked = e.target.checked;

        if (checked) {
            if (selectedOptions.length < 4) {
                setSelectedOptions([...selectedOptions, value]);
            } else {
                e.target.checked = false;
            }
        } else {
            setSelectedOptions(selectedOptions.filter(option => option.bookmark_id !== value.bookmark_id));
        }
    };
    return (
        <>
            <div className={`infoBox cover_hidden`} id="bookmark">
                <ul className="tabMenuUl_b">
                    <li className={`tabMenu ${tabIndex === 0 ? "active" : ""}`} style={{ width: 100 / (props.bookMarks.length + 1) + '%' }} onClick={() => { setTabIndex(0) }}>{t('전체')}</li>
                    {props.bookMarks.map((item, index) => {
                        return <li key={index} className={`tabMenu ${tabIndex === index + 1 ? "active" : ""}`} style={{ width: 100 / (props.bookMarks.length + 1) + '%' }} onClick={() => { setTabIndex(index + 1) }}>{item.bookMarkListName}</li>
                    })}
                </ul>
                <div className="tabContent bookmarks">
                    <ul className="bookmark_list">
                        {props.bookMarks.length === 0 ?
                            <div className="bookmark_empty_message">
                                {t('북마크를 등록해주세요!')}
                            </div>
                            : tabIndex === 0 ? props.bookMarks.map((list_item, list_index) => {
                                return list_item.bookMarks.map((item, index) => {
                                    return (
                                        <li key={index} className='bookmark' onClick={(e) => { console.log(e.target.tagName); if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'LABEL') { bookmarkClick(item.bookmark_id) } }}>
                                            <div className="color" style={{ background: list_item.bookMarkListColor }}></div>
                                            <div className="name">{item.landName}</div>
                                            <div className="title">{displayAddress(item.bookmark_id)}</div>
                                            <div className="plot">{t('대지면적')} : {item.plotAr}㎡ ({(item.plotAr * 0.3025).toFixed(2)}{t('평')})</div>
                                            <input type="checkbox" id={`check${list_index}${index}`} className="checkbox" value={JSON.stringify({ ...item, bookMarkListColor: list_item.bookMarkListColor })} onChange={handleCheckboxChange}></input>
                                            <label htmlFor={`check${list_index}${index}`}></label>
                                        </li>
                                    )
                                })
                            }) : ''
                        }
                        {props.bookMarks.map((list_item, list_index) => {
                            if (tabIndex === list_index + 1) {
                                return list_item.bookMarks.map((item, index) => {
                                    return (
                                        <li key={index} className='bookmark' onClick={(e) => { console.log(e.target.tagName); if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'LABEL') { bookmarkClick(item.bookmark_id) } }}>
                                            <div className="color" style={{ background: list_item.bookMarkListColor }}></div>
                                            <div className="name">{item.landName}</div>
                                            <div className="title">{displayAddress(item.bookmark_id)}</div>
                                            <div className="plot">{t('대지면적')} : {item.plotAr}㎡ ({(item.plotAr * 0.3025).toFixed(2)}{t('평')})</div>
                                            <input type="checkbox" id={`check${index}`} className="checkbox" value={JSON.stringify({ ...item, bookMarkListColor: list_item.bookMarkListColor })} onChange={handleCheckboxChange}></input>
                                            <label htmlFor={`check${index}`}></label>
                                        </li>
                                    )
                                })
                            }
                        })}

                    </ul>
                </div>
                <div className={`btns btn_b ${props.informationHeight !== 20 ? "" : "close"}`} onClick={EstmtBtnClick}>{t('견적 비교하기')}
                    <div className="left-chevron"></div></div>
            </div>
            {props.CmprsEstmtState === false ? '' : <CmprsEstmt selectedOptions={selectedOptions} bookMarks={props.bookMarks} onClick={props.onClick} infoClick={props.infoClick} />}
        </>

    )
}

function AllowBuildingList(props) {
    const t = useT();
    function handleChangeSelect(e) {
        props.setAllowBuildingCount(e.target.value);
    }
    return (
        <div className="content selectBox">
            {props.addressInfo?.allowBuildingList?.allowBuildingListSubCategory?.length === 0 ?
                t("건축불가") :
                <div className="selectWrap">
                    <div className="allowBuildingTitle">{t('건축가능용도')}</div>
                    <select className="allowBuildingList" value={props.allowBuildingCount} onChange={handleChangeSelect}>
                        {props.addressInfo?.allowBuildingList?.allowBuildingListSubCategory?.map((item, index) => {
                            return <option key={index} value={index}>{t(item.name)}</option>;
                        })}
                    </select>

                </div>
            }
        </div>
    )
}

function BookMarkWindow({ bookMarkWindow, addressInfo, userInfo, setBookMarks, setBookMarkState, bookMarks, setBookMarkWindow }) {
    const t = useT();
    const [newList, setNewList] = useState(true);
    const [newListLength, setNewListLength] = useState(0);
    const [nameLength, setNameLength] = useState(0);
    const [memoLength, setMemoLength] = useState(0);
    const [selectedColor, setSelectedColor] = useState();
    const [bookMarkListBtnState, setBookMarkListBtnState] = useState(false);
    const [bookMarkBtnState, setBookMarkBtnState] = useState(false);
    const navigate = useNavigate();

    const color_list = [
        '#f25cb6', '#1DB075', '#FECE25', '#22618C', '#8A94BE'
    ]

    function listBtnCheck() {
        if (selectedColor !== undefined && newListLength !== 0) {
            setBookMarkListBtnState(true);
        } else {
            setBookMarkListBtnState(false);
        }
    }

    function checkLength(e, setNameLength, maxLength) {
        let length = e.target.value.length;
        if (length >= maxLength) {
            e.target.value = e.target.value.slice(0, maxLength);
            length = maxLength;
        }
        setNameLength(length);
    }

    function addBookMarkList() {
        if (userInfo === null || !addressInfo) { window.setModalMessage(t('로그인 후 이용가능합니다.')); navigate('/login', { state: { returnUrl: window.location.href } }); return false }
        const user = userInfo;
        const form = document.bookMark;
        const color = color_list[selectedColor];
        const listName = form.listName.value;
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_BACKEND_SERVER}/bookmark/addList`,
            data: {
                _id: user._id,
                provider: user.provider,
                listName: listName,
                color: color
            },
            withCredentials: true
        }).then((response) => {
            console.log(response.data);
            setBookMarks(response.data);
        }).catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
                window.setModalMessage(t('로그인 후 이용가능합니다.'));
                setBookMarkState(false);
                navigate('/login', { state: { returnUrl: window.location.href } });
            }
        });

    }

    function addBookMark() {
        if (userInfo === null || !addressInfo) { window.setModalMessage(t('로그인 후 이용가능합니다.')); navigate('/login', { state: { returnUrl: window.location.href } }); return false }
        const user = userInfo;
        const form = document.bookMark;
        const bookMarkListIndex = form.book_mark_list.value;
        const bookMarkMemo = form.bookMarkMemo.value;
        let landName;
        if (form.landName.value === '') {
            return false;
        } else {
            landName = form.landName.value;
        }
        const bookmark_id = addressInfo?.name?.jibunAddress?.replace(/\s{2,}/gi, ' ');

        axios({
            method: 'post',
            url: `${process.env.REACT_APP_BACKEND_SERVER}/bookmark/add`,
            data: {
                _id: user._id,
                provider: user.provider,
                bookmark_id: bookmark_id,
                landName: landName,
                plotAr: addressInfo?.construct?.PLOT_AR,
                bookMarkListIndex: bookMarkListIndex,
                bookMarkMemo: bookMarkMemo
            },
            withCredentials: true
        }).then((response) => {
            console.log(response.data);
            setBookMarks(response.data);
            setBookMarkWindow(false);
            setBookMarkState(true);
        }).catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
                window.setModalMessage(t('로그인 후 이용가능합니다.'));
                setBookMarkState(false);
                navigate('/login', { state: { returnUrl: window.location.href } });
            }
        });
    }

    useEffect(() => {
        if (bookMarks.length >= 3 && newList === true) {
            setTimeout(() => { setNewList(false) }, 1000);
        }
    }, [newList, bookMarks]);

    useEffect(() => {
        listBtnCheck();
    }, [selectedColor, newListLength]);

    return (
        <div className={bookMarkWindow === true ? 'bookmark_window' : 'bookmark_window hidden'} >
            <form name="bookMark">
                <div className="list_add_wrap" onClick={() => { setNewList(!newList) }}>
                    {t('새 리스트 추가')}
                    <div className={newList === true ? 'list_icon rotate' : 'list_icon'}></div>
                </div>
                <div className="content_wrap">
                    {newList === true ?
                        bookMarks.length >= 3 ? <div className="warningMessage">{t('리스트는 최대 3개까지 입니다.')}</div> :
                            <>
                                <div className="name_wrap">
                                    <input className="bookmark_name" name="listName" type="text" placeholder={t('새 리스트명을 입력해주세요')} onChange={(e) => { checkLength(e, setNewListLength, 6) }}></input>
                                    <div className="text_counter"><span>{newListLength}</span>/6</div>
                                </div>
                                <div className="color_wrap">
                                    <div className="title">{t('색상 선택')}</div>
                                    <ul className="color_ul clearfixed">
                                        {color_list.map((item, index) => {
                                            return (
                                                <li className={selectedColor === index ? 'color checked' : 'color'} style={{ background: item }} key={index} onClick={() => { setSelectedColor(index) }}></li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <div className={bookMarkListBtnState === true ? "submit_btn" : "submit_btn disabled"} onClick={addBookMarkList}>{t('리스트 저장')}</div>
                            </> : ''

                    }
                    <div className="name_wrap">
                        <input className="bookmark_name" name="landName" type="text" placeholder={t('토지의 별명을 입력해주세요.')} onChange={(e) => { checkLength(e, setNameLength, 20) }}></input>
                        <div className="text_counter"><span>{nameLength}</span>/20</div>
                    </div>
                    <div className="list_wrap">
                        <ul className="bookmark_add_list_con">
                            {bookMarks.length === 0 ?
                                <li className="bookmark_add_list clearfixed">
                                    <div className="warningMessage">{t('새 리스트를 추가해 주세요.')}</div>
                                </li> :
                                bookMarks.map((item, index) => {
                                    return (
                                        <li className="bookmark_add_list clearfixed" key={index}>
                                            <div className="color" style={{ background: item.bookMarkListColor }}></div>
                                            <div className="title">{item.bookMarkListName}</div>
                                            <input type="radio" id={`check_add_bookmark_${index}`} className="checkbox" name="book_mark_list" value={index} onClick={() => { setBookMarkBtnState(true) }}></input>
                                            <label htmlFor={`check_add_bookmark_${index}`}></label>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <div className="memo_wrap">
                        <div className="title">{t('메모')}</div>
                        <div className="memo_con">
                            <textarea className="memo" name="bookMarkMemo" onChange={(e) => { checkLength(e, setMemoLength, 30) }}></textarea>
                            <div className="text_counter"><span>{memoLength}</span>/30</div>
                        </div>
                        <div className={(bookMarkBtnState === true && document.bookMark.landName.value !== '') ? "submit_btn" : "submit_btn disabled"} onClick={addBookMark}>{t('저장')}</div>
                    </div>
                </div>

            </form>
        </div>
    )
}

function AllowBuildingListSubCategory({ subCategoryWindow, allowBuildingCount, addressInfo, setSubCategoryWindow }) {
    const t = useT();
    return (
        <div className={subCategoryWindow === true ? 'subcategory_window' : 'subcategory_window hidden'}>
            <div className="list_add_wrap">
                {t('건축용도 가능여부')}
            </div>
            <div className="close_btn" onClick={() => { setSubCategoryWindow(false) }}></div>
            <div className="content_wrap">
                {addressInfo?.allowBuildingList?.allowBuildingListSubCategory?.length === 0 ? '' :
                    addressInfo?.allowBuildingList?.allowBuildingListSubCategory?.[allowBuildingCount]?.list?.map((item, index) => {
                        let allowAble;
                        if (!item.조건제한예외사항) {
                            allowAble = item.가능여부
                        } else {
                            allowAble = '건축제한'
                        }
                        if(allowAble === '건축제한'){
                            allowAble = '조건부가능'
                        }
                        return (
                            <li
                                className={allowAble === '건축제한' || allowAble === '조건부가능' ? "sub_category_list pointer" : "sub_category_list"}
                                key={index}
                                onClick={(e) => {
                                    const liEl = e.currentTarget.closest('li');
                                    const warningTxtEl = liEl.querySelector('.warning_txt');
                                    if (warningTxtEl) {
                                        warningTxtEl.classList.toggle('open');
                                    }
                                }}
                            >
                                <div className="list_wrap">
                                    <div className="title_wrap">
                                        <div className="title">{t(item.토지이용명.replace(/。/g, ''))}</div>
                                        {item.조건제한예외사항 !== undefined && (
                                            <div
                                                className="warning"
                                            >
                                                {t('[조건·제한·예외사항]')}
                                            </div>
                                        )}
                                    </div>
                                    <div className="allowable">{t(allowAble)}</div>
                                </div>
                                {(allowAble === '건축제한' || allowAble === '조건부가능') && (
                                    <div className="warning_txt">
                                        {currentLang === 'en'
                                            ? 'Conditions apply \u2014 see Toji-Eum below for the full text.'
                                            : t('(조건·제한·예외사항 : {detail})', { detail: item.조건제한예외사항 })}
                                    </div>
                                )}
                            </li>
                        )
                    })
                }
            </div>
            <div className="eum_notice">{t('보다 자세한 내용은 토지이음에서 확인해주시길 바랍니다.')}</div>
            <div className="btn_wrap">
                <a className="btn_c black" target="_blank" href={`http://www.eum.go.kr/web/ar/lu/luLandDet.jsp?selSido=11&selSgg=620&selUmd=0102&selRi=00&landGbn=1&bobn=501&bubn=33&sggcd=&isNoScr=script&mode=search&selGbn=umd&s_type=1&add=land&pnu=${addressInfo?.pnu}`}>{t('토지이음 바로가기')}</a>
            </div>
        </div>
    )
}

export default InformationBeta;